import {
    Component,
    ElementRef,
    OnInit,
    Signal,
    computed,
    effect,
    inject,
    signal,
    AfterViewInit,
    input,
    InputSignal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IqStyleProcessorStateService } from '../state';
import { IqCssClassnames, IqCssClassNamesRule } from '../models';
import {
    IqEventBusBrokerHandler,
    IqEventBusBrokerService,
} from '@dat/iq-event-bus';
import { uniqueId } from 'lodash';

type RuleResponseTypes = 'CSS_CLASS_COMPONENT';
type SbCssClassComponentResponse = {
    sbCssClassComponentId: string;
    type: RuleResponseTypes;
};

@Component({
    selector: 'iq-style-processor-css-class',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './iq-style-processor-css-class.component.html',
    styleUrl: './iq-style-processor-css-class.component.scss',
})
export class IqStyleProcessorCssClassComponent
    implements OnInit, AfterViewInit
{
    /**
     * This is a record where the keys are the classes
     * we want to add and the values are the rules selectors
     * to apply the classes to.
     *
     * @deprecated
     */
    classNames: InputSignal<IqCssClassnames> = input({});

    cssClassNames: InputSignal<IqCssClassNamesRule[]> = input([]);

    private _registeredAction: Record<string, IqEventBusBrokerHandler>;
    spShowElementId: string = uniqueId('sp-css-class-component');
    private _eventBroker: IqEventBusBrokerService = inject(
        IqEventBusBrokerService,
    );
    appliedClassesSignal: Signal<[string, string[]][]> = signal([]);
    appliedClasses: Signal<[string, string[]][]> = computed(
        (): [string, string[]][] => {
            return this.appliedClassesSignal();
        },
    );

    // Call this in the OnInit Function
    private _setAppliedClassesSignal(): void {
        this.appliedClassesSignal = this._state.appliedClasses(
            this.classNames(),
        );
    }

    constructor(
        private _state: IqStyleProcessorStateService,
        elementRef: ElementRef,
    ) {
        effect(() => {
            const appliedClasses: [string, string[]][] = this.appliedClasses();

            if (!appliedClasses?.length) return;

            appliedClasses.forEach(
                ([className, cssSelectors]: [string, string[]]) => {
                    cssSelectors.forEach((cssSelector: string) => {
                        const elements =
                            elementRef.nativeElement?.querySelectorAll(
                                cssSelector,
                            );

                        elements.forEach((element: HTMLElement) => {
                            element.classList.add(className);
                        });
                    });
                },
            );
        });
    }

    ngOnInit() {
        this._setAppliedClassesSignal();

        // this._registeredAction = this._eventBroker.registerMap({
        //     'type:rules:evaluator:run:success': {
        //         callback: (eventInfo: SbCssClassComponentResponse) => {
        //             this._runRules(eventInfo);
        //         },
        //     },
        // });

        // this._eventBroker.dispatch({
        //     name: 'type:rules:evaluator:run',
        //     payload: {
        //         spShowElementId: this.spShowElementId,
        //         type: 'SHOW_ELEMENT',
        //         rules: this.rules(),
        //         operator: this.ruleOperator(),
        //     },
        // });
    }

    ngAfterViewInit() {
        this._checkRules();
    }

    private _checkRules() {
        // if (!this.rules()?.length) {
        //     this.show.set(true);
        //     return;
        // }
        // this._registeredAction = this._eventBroker.registerMap({
        //     'type:rules:evaluator:run:success': {
        //         callback: (eventInfo: SpShowElementResponse) => {
        //             this._runRules(eventInfo);
        //         },
        //     },
        // });
        // this._eventBroker.dispatch({
        //     name: 'type:rules:evaluator:run',
        //     payload: {
        //         spShowElementId: this.spShowElementId,
        //         type: 'SHOW_ELEMENT',
        //         rules: this.rules(),
        //         operator: this.ruleOperator(),
        //     },
        // });
    }

    private _runRules(eventInfo: SbCssClassComponentResponse) {
        // if (get(eventInfo, 'spShowElementId') !== this.spShowElementId) return;
        // const response: Record<RuleResponseTypes, () => any> = {
        //     SHOW_ELEMENT: () => {
        //         this.show.set(true);
        //     },
        // };
        // if (!response[eventInfo.type]) return;
        // response[eventInfo.type]?.();
    }
}
